"use client";
import GuessDialog from "@/components/GuessDialog";
import useVidyaGrid from "@/hooks/useVidyaGrid";
import ChallengeCell from "@/components/ChallengeCell";
import GuessCell from "@/components/GuessCell";
import LivesMeter from "@/components/LivesMeter";
import GamerOverDialog from "@/components/GameOverDialog";
import { Button } from "@/components/shadcn/Button";
import Spinner from "@/components/ui/Spinner";

export default function Home() {
  const game = useVidyaGrid();

  if (!game.ready)
    return (
      <div className="animate-pulse flex justify-center items-center gap-4">
        <Spinner className="w-8 h-8 text-deep-purple-700" />
        <h2 className="scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0">
          Now loading...
        </h2>
      </div>
    );

  return (
    <div>
      <LivesMeter lives={game.tries} startingLives={game.startingLives} />

      <div className="max-w-[1028px] p-4 grid grid-cols-4 gap-2 2xl:gap-4 justify-items-center">
        <div />
        {game.colChallenges.map((colCha) => (
          <ChallengeCell
            key={`col-cha-${colCha.type}`}
            challenge={colCha}
            isCol
          />
        ))}

        {game.rowChallenges.map((rowCha) => {
          const clickableGrid = game.colChallenges.map((colCha) => (
            <GuessCell
              key={`${colCha.type}_${rowCha.type}`}
              attemptGuess={game.attemptGuess}
              getSolution={game.getSolution}
              colCha={colCha}
              rowCha={rowCha}
              gameState={game.gameState}
            />
          ));

          return (
            <>
              <ChallengeCell
                key={`row-cha-${rowCha.type}`}
                challenge={rowCha}
              />
              {clickableGrid}
            </>
          );
        })}
      </div>

      <div className="grid gap-2">
        <Button className="mx-4" onClick={game.resetGame}>
          New game
        </Button>
        <small className="mx-4 text-pretty text-center text-sm text-gray-400 font-medium leading-none">
          *Games generated procedurally, if a game is unsolvable, press
          &quot;New Game&quot;
        </small>
      </div>

      <GuessDialog
        showModal={game.guessing}
        dialogLabel={game.dialogLabel}
        gotWrong={game.gotWrong}
        tries={game.tries}
        handleGuess={game.handleGuess}
        handleClose={() => {
          game.setGuessing(!game.guessing);
        }}
      />

      <GamerOverDialog gameState={game.gameState} resetGame={game.resetGame} />
    </div>
  );
}
